import { ComponentView, DelegatedObservableArrayChangeListenner, ObservableArray, View } from "binder"
import { chartData } from "../pieChart/pieChart-viewModel";
import { linearChartData, LinearChartViewModel } from "./linearChart-viewModel"
declare var Highcharts:any;

export class LinearChartView extends ComponentView<LinearChartViewModel>{
    GetViewUniqueId(): string {
        return "V-5EBE3E97-F76B-434A-9FB1-DFADD4A9918E"
    }
    loadHtml(): string {
        let element = require('./linearChart.html').default;
        let style = require('./linearChart.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set chartdata(v: linearChartData) { this._chartdata = v; this.render(); } public get chartdata(): linearChartData { return this._chartdata;} private _chartdata: linearChartData;
    
    private _porentElement:any;
    onRenderCompleted(){
        this._porentElement = this.firstlevelElement.querySelector('.V-5EBE3E97-F76B-434A-9FB1-DFADD4A9918E');
        this.render();
    }

    render(){
        if(this._porentElement==null || this.chartdata == null)
            return;

        Highcharts.chart(this._porentElement, {
            yAxis: {
                title: {
                    text: 'Number of Users'
                }
            },
            chart:{
                styledMode: true,
                type: 'line'
            },
            title: {
                text: ''
            },
            xAxis: {
                    categories:this.chartdata.x
            },
        
            legend: {
                layout: 'horizontal',
                align: 'bottom',
                verticalAlign: 'bottom'
            },
        
            
            series:this.chartdata.series.map(x=>{return {
                name:x.name,
                data:x.values
            };}),
            
        
        });
    }
}
